/**
 * @import { AnsiPalette } from '../ansi.types.js'
 */

/** @type {AnsiPalette} */
export default {
  foreground: '#D6DEEB',
  background: '#011627',
  'background-hover': '#0B2031',
  'background-selected': '#152A3B',
  black: '#011627',
  red: '#EF5350',
  green: '#22DA6E',
  yellow: '#ADDB67',
  blue: '#82AAFF',
  magenta: '#C792EA',
  cyan: '#21C7A8',
  white: '#FFFFFF',
  'bright-black': '#575656',
  'bright-red': '#EF5350',
  'bright-green': '#22DA6E',
  'bright-yellow': '#FFEB95',
  'bright-blue': '#82AAFF',
  'bright-magenta': '#C792EA',
  'bright-cyan': '#7FDBCA',
  'bright-white': '#FFFFFF',
};
